import { withInstall } from '@/utils/global'
import banner from './src/index.vue'

const Banner = withInstall(banner)

export default Banner
